import type { RefObject } from 'react'

import ChatContainer from '../containers/ChatContainer'

interface Props {
  chatId: number | undefined
  isLoggedIn: boolean
  isDevMode: boolean
  isSpoofed: boolean
  spoofingAgentEmail?: string
  navigateToNewChatRoute: () => void
  selectedBookingItemIds?: Array<string>
  onBookingItemsAdded?: (bookingItemIds: Array<string>) => void
  handleSubmit: (message: string) => Promise<void>
  handleMultiChoiceSelectionChange: (selection: Array<string>) => void
  activeMultiChoiceSelection: Array<string>
  prefilledSelectionTags?: Array<string>
  mobileSelectionText: string | undefined
  offerContextTag: { label: string; offerId: string } | undefined
  handleRemoveTag: (tag: string) => void
  onRemovePrefilledSelectionTag?: (tag: string) => void
  chatInputRef: RefObject<HTMLTextAreaElement | null>
}

const DEFAULT_SELECTED_BOOKING_ITEM_IDS: Array<string> = []

function TripChatMobileChatView({
  chatId,
  isLoggedIn,
  isDevMode,
  isSpoofed,
  spoofingAgentEmail,
  navigateToNewChatRoute,
  selectedBookingItemIds = DEFAULT_SELECTED_BOOKING_ITEM_IDS,
  onBookingItemsAdded,
  handleSubmit,
  handleMultiChoiceSelectionChange,
  activeMultiChoiceSelection,
  prefilledSelectionTags,
  mobileSelectionText,
  offerContextTag,
  handleRemoveTag,
  onRemovePrefilledSelectionTag,
  chatInputRef,
}: Props) {
  return (
    <ChatContainer
      chatId={chatId}
      isLoggedIn={isLoggedIn}
      isDevMode={isDevMode}
      isSpoofed={isSpoofed}
      spoofingAgentEmail={spoofingAgentEmail}
      navigateToNewChatRoute={navigateToNewChatRoute}
      handleSubmit={handleSubmit}
      handleMultiChoiceSelectionChange={handleMultiChoiceSelectionChange}
      activeMultiChoiceSelection={activeMultiChoiceSelection}
      prefilledSelectionTags={prefilledSelectionTags}
      mobileSelectionText={mobileSelectionText}
      offerContextTag={offerContextTag}
      handleRemoveTag={handleRemoveTag}
      onRemovePrefilledSelectionTag={onRemovePrefilledSelectionTag}
      selectedBookingItemIds={selectedBookingItemIds}
      onBookingItemsAdded={onBookingItemsAdded}
      chatInputRef={chatInputRef}
      autoFocusChatInput={false}
      compactDisclaimer
      enableMapActions={false}
      fitAvailableHeight
    />
  )
}

export default TripChatMobileChatView
